import { render, staticRenderFns } from "./no-weixin-account.vue?vue&type=template&id=0a1d72ca&scoped=true"
import script from "./no-weixin-account.vue?vue&type=script&lang=js"
export * from "./no-weixin-account.vue?vue&type=script&lang=js"
import style0 from "./no-weixin-account.vue?vue&type=style&index=0&id=0a1d72ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1d72ca",
  null
  
)

export default component.exports